import { TRADE_TYPE } from "./trade-offer.model";
import { Model } from "./model";
import { Offer } from "./offer";

export class IndexTrade extends Model {
	private amount: string = "";
	private type: TRADE_TYPE = undefined;
	private fiat_id: string = "";
	private asset_id: string = "";
	private bfc_used: boolean = false;
	private sell_all: boolean = false;

	public constructor(data: Offer) {
		super();

		if (data) {
			this.amount = data.getAmountFiat();
			this.type = data.getType();
			this.fiat_id = data.getFiatId();
			this.bfc_used = data.bestFeeOptIn;
			this.sell_all = data.getSellAll();
			this.asset_id = data.getCurrencyId();
		}
	}

	public getAmount(): string {
		return this.amount;
	}

	public getType(): TRADE_TYPE {
		return this.type;
	}

	public getFiatId(): string {
		return this.fiat_id;
	}

	public getBfcUsed(): boolean {
		return this.bfc_used;
	}

	public getSellAll(): boolean {
		return this.sell_all;
	}

	public getAssetId(): string {
		return this.asset_id;
	}
}
